import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Menu, X } from 'lucide-react';
import logoImage from '@/assets/images/contemplate black_edited.png';

const Navigation = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled 
          ? 'bg-[#efede6]/90 backdrop-blur-xl shadow-sm' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-8 py-5">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src={logoImage} 
              alt="Contemplate"
              className="h-8"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10">
            <button 
              onClick={() => scrollToSection('how-it-works')}
              className="text-[#202020]/70 hover:text-[#202020] transition-colors text-sm tracking-wide"
            >
              How It Works
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className="text-[#202020]/70 hover:text-[#202020] transition-colors text-sm tracking-wide"
            >
              Stories
            </button>
            <button 
              onClick={() => scrollToSection('pricing')}
              className="text-[#202020]/70 hover:text-[#202020] transition-colors text-sm tracking-wide"
            >
              Pricing
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-[#202020]/70 hover:text-[#202020] transition-colors text-sm tracking-wide"
            >
              FAQ
            </button>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              onClick={() => navigate('/checkout')}
              className="bg-[transparent] hover:bg-[#202020] text-[#202020] hover:text-[#efede6] px-6 py-2.5 rounded-lg transition-all duration-300 hover:scale-105 text-sm border-2 border-[#202020]"
            >
              Become a Peaceful Parent
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-[#202020]" />
            ) : (
              <Menu className="w-6 h-6 text-[#202020]" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-6 pb-6 border-t border-[#202020]/10 pt-6">
            <div className="flex flex-col gap-5">
              <button 
                onClick={() => scrollToSection('how-it-works')}
                className="text-[#202020]/70 hover:text-[#202020] transition-colors text-left text-sm"
              >
                How It Works
              </button>
              <button 
                onClick={() => scrollToSection('testimonials')}
                className="text-[#202020]/70 hover:text-[#202020] transition-colors text-left text-sm"
              >
                Stories
              </button>
              <button 
                onClick={() => scrollToSection('pricing')}
                className="text-[#202020]/70 hover:text-[#202020] transition-colors text-left text-sm"
              >
                Pricing
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className="text-[#202020]/70 hover:text-[#202020] transition-colors text-left text-sm"
              >
                FAQ
              </button>
              <Button 
                onClick={() => {
                  navigate('/checkout');
                  setIsMobileMenuOpen(false);
                }}
                className="bg-[transparent] hover:bg-[#202020] text-[#202020] hover:text-[#efede6] px-6 py-2.5 rounded-lg mt-2 w-full text-sm border-2 border-[#202020]"
              >
                Become a Peaceful Parent
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
